function Footer() {
    return (
        <div className="cls7">
            <div className="cls7_1">
                <div className="cls7_1_1">
                    <p>Udemy Business</p>
                    <p>Teach On Udemy</p>
                    <p>About Us</p>
                    <p>Contact Us</p>
                    <p>Get the app</p>
                </div>
                <div className="cls7_1_1">
                    <p>Careers</p>
                    <p>Blog</p>
                    <p>Help and Support</p>
                    <p>Affiliate</p>
                    <p>Investors</p>
                </div>
            </div>

            <div className="cls7_2">
                <h1>Udemy</h1>
                <p>&copy; Udemy,Inc</p>
            </div>
        </div>
    )
}

export default Footer